import React, { useEffect, useState } from "react";
import Navbar from "../../Components/Navbar";
import { LiaAngleLeftSolid } from "react-icons/lia";
import { useLocation, useNavigate } from "react-router-dom";
import loc from "../../Assets/Images/location_on.png";
import AboutRealEstate from "../../Components/AboutRealEstate";
import PropertyImages from "../../Components/PropertyImages";
import RealEstateCta from "../../Components/RealEstateCta";
import RealEstateReturnsCalculator from "../../Components/RealEstateReturnsCalculator";
import { getBalance } from "../../store/actions/dashboard/manageFunds";
import AmountModal from "../../Components/AmountModal";
import PinConfirmation from "../../Components/PinConfirmation";
import { submitRealEstateInvestment } from "../../store/actions/realEstate/submitRealEstateInvestment";
import { useDispatch } from "react-redux";

const RealEstateDetails = () => {
  const dispatch = useDispatch();
  const { state } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const navigate = useNavigate();

  const [showConfirmationModal, setShowConfirmationModal] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    dispatch(
      getBalance({
        cb: () => {},
      })
    );
    setIsModalOpen({
      investment: state,
    });
  };

  const handleConfirm = ({
    otp,
    adminFee,

    amount,
    id,
    name,

    investment,
  }) => {
    const total = adminFee + +amount;
    const data = {
      data: {
        unit: Number(amount),

        property_product_id: Number(investment?.id),

        payment_type: "transfer",
        transaction_pin: otp,
      },

      failed: () => {
        setShowConfirmationModal(null);
        setIsModalOpen(showConfirmationModal?.showModalData);
        // navigate(`/investment/realestate/summary/${id}`, {
        //   state: {
        //     adminFee,
        //     amount,
        //     investment,
        //   },
        // });
      },
      cb: (response) => {
        setShowConfirmationModal(null);
        navigate(`/investment/realestate/summary/${id}`, {
          state: {
            adminFee,
            amount,
            investment,
            response,
            portfolioID: response?.portfolio_id,
          },
        });
      },
    };

    dispatch(submitRealEstateInvestment(data));
  };

  useEffect(() => {
    if (!state) {
      navigate(-1);
    }
  }, []);

  return (
    <div className="flex flex-col bg-[#F9FAFA] gap-6 pt-3 pb-3 items-center min-h-screen">
      <Navbar type={3} />

      <div className="w-[95%] h-full flex flex-col rounded-[12px] gap-10 p-10 bg-[#FFF] border-[#F2F2F2] border-[1.1px] drop-shadow-custom max-w-[1664px]">
        <div
          onClick={() => navigate(-1)}
          className="flex cursor-pointer items-center mb-4"
        >
          <LiaAngleLeftSolid size={18} color="#131E3D" className="mx-[2px]" />
          <h3 className="text-[14px] font-[400] text-[#131E3D]">Back</h3>
        </div>

        <div className=" 2xl:min-w-[1050px] mx-auto items-center">
          <div className="flex gap-3  pb-3 flex-wrap items-end justify-between ">
            <div className="text-[32px] leading-tight font-[500] text-[#131e3d]">
              {state?.name}
            </div>
            <div className="flex pb-1 items-center gap-[5px]">
              <img src={loc} alt="" className="w-[14px] h-[14px]" />
              <div className="text-[14px] font-[400] text-[#9c9c9e]">
                {state?.location}
              </div>
            </div>
          </div>
          <div className="flex w-full lg:flex-row flex-col justify-center items-start gap-[30px]">
            <AboutRealEstate state={state} />

            <div className="flex flex-col justify-center lg:items-end">
              <PropertyImages state={state} />
              <RealEstateCta state={state} openModal={openModal} />
            </div>
          </div>
          {/* <div className=" mt-6">
            <div className="flex flex-col justify-start items-start gap-4">
              <div className="text-[16px] font-[500] text-[#131e3d]">
                Estimate your returns
              </div>
              <RealEstateReturnsCalculator
                state={state}
                openModal={openModal}
              />
            </div>
          </div> */}
        </div>
      </div>
      {isModalOpen ? (
        <div className="fixed top-0 left-0 inset-0 flex items-center justify-center bg-[rgba(19,30,61,0.4)] z-40">
          <AmountModal
            type={"REAL_ESTATE"}
            values={isModalOpen?.investment}
            admin_fee={isModalOpen?.investment?.admin_fee}
            handleClose={() => setIsModalOpen(false)}
            next={(value) => {
              setShowConfirmationModal({ value, showModalData: isModalOpen });
              setIsModalOpen(false);
            }}
          />
        </div>
      ) : (
        <></>
      )}
      {showConfirmationModal ? (
        <div className=" top-0 left-0 w-screen h-screen z-50 flex justify-center items-center fixed bg-[rgba(19,30,61,0.4)]">
          <PinConfirmation
            handleClose={() => {
              setShowConfirmationModal(null);
            }}
            back={() => {
              setShowConfirmationModal(null);
              setIsModalOpen(showConfirmationModal?.showModalData);
            }}
            handleSubmit={(otp) => {
              handleConfirm({
                ...showConfirmationModal?.value,
                otp,
              });
            }}
            buttonTitle={"Submit Investment"}
            subTitle={"Confirm your Halvest PIN to Invest"}
          />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default RealEstateDetails;
